import { Auth0ContextInterface } from '@auth0/auth0-react';
import { api } from '@services';
import { AxiosRequestConfig } from 'axios';

/**
 * Try to Refresh jwt between requests if expired.
 *
 * # Note:
 *  This assumes `getAccessTokenSilently` **caches** and returns the **cached** token if available, and makes a request for a new one otherwise.
 */
export function getRefreshInterceptor(
  getAccessTokenSilently: Auth0ContextInterface['getAccessTokenSilently'],
) {
  async function refresh(req: AxiosRequestConfig) {
    // Should get a new token at any call where token expires
    const newOrCurrentValidToken = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    api.defaults.headers.authorization = `Bearer ${newOrCurrentValidToken}`;
    req.headers.authorization = `Bearer ${newOrCurrentValidToken}`; // set for this req as well
    return req;
  }
  return refresh;
}
